import * as Api from '@ViewModels';

/**
 * Whether an edit that writes the picture out again as a new still, such as a crop or an AI edit,
 * keeps what it shows. It cannot reframe a video, and it would flatten an animated GIF to one frame.
 */
export const isRedrawable = (attachment: Api.IFileAttachment) => {
	const mimeType = attachment.mimeType?.toLowerCase() ?? '';
	return !mimeType.startsWith('video/') && !mimeType.includes('gif');
};
